import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Snackbar,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import moment from "moment";
import { UrlApi } from "../../../../services/apirest";
import { putData } from "../../../../services/library";

function NuevoMovimiento({ open, onClose, vehiculo }) {
  const [formData, setFormData] = useState({
    observaciones: "",
    kilometraje_final: vehiculo.kilometraje,
    fecha: moment(new Date()).format("YYYY-MM-DD"),
  });

  console.log(vehiculo);
  
  const [disbtn, setDisbtn] = useState(false);
  const [openSnack, setOpenSnack] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [severity, setSeverity] = useState("info"); // success | error | warning | info

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenSnack(false);
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  if (formData.kilometraje_final <= vehiculo.kilometraje) {
    setMensaje("El kilometraje final no puede ser menor o igual al actual");
    setSeverity("error");
    setOpenSnack(true);
    return;
  }

  setDisbtn(true);
  try {
    // 1️⃣ Actualizar el vehículo
    await fetch(UrlApi + "/vehiculos/" + vehiculo.id, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        kilometraje: formData.kilometraje_final,
      }),
    })
      .then((res) => {
        if (res.ok) {
          // setColorMensaje("#D4EFDF");
          setMensaje("Kilometraje actualizado con éxito");
          setOpenSnack(true);
        } else {
          // setColorMensaje("#F1948A");
          setMensaje("Error al actualizar el vehículo");
          setOpenSnack(true);
          throw new Error("PUT vehículo fallido");
        }
      })
      .catch((err) => {
        console.error(err);
        // set("#F1948A");
        setMensaje("Error en la conexión con el servidor");
        setOpenSnack(true);
      });

    // 2️⃣ Guardar movimiento
    const resMov = await fetch(UrlApi + "/vehiculos_movimientos", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        vehiculo: vehiculo.id,
        observaciones: formData.observaciones,
        kilometraje_inicial: vehiculo.kilometraje,
        kilometraje_final: formData.kilometraje_final,
        fecha: formData.fecha,
        usuario: localStorage.getItem("user"),
      }),
    });

    if (!resMov.ok) throw new Error("Error al guardar movimiento");

    // setColorMensaje("#D4EFDF");
    setMensaje("Movimiento guardado con éxito");
    setOpenSnack(true);

    // Cerrar modal después de un pequeño delay
    setTimeout(() => onClose(), 500);

  } catch (err) {
    console.error(err);
    // setColorMensaje("#F1948A");
    setMensaje(err.message || "Error en la operación");
    setOpenSnack(true);
  } finally {
    setDisbtn(false);
  }
};


  return (
    <>
      <Dialog fullWidth open={open} onClose={onClose} maxWidth="md">
        <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography fontSize={20} align="center" color="#ffffff">
              Nuevo Movimiento
            </Typography>
          </DialogTitle>
        </Box>
        <form autoComplete="off" onSubmit={handleSubmit}>
          <DialogContent>
            <Box
              backgroundColor="#F4F6F6"
              px={2}
              py={2}
              border={0.5}
              borderColor={"#ABB2B9"}
              borderRadius={3}
            >
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    label="Observaciones"
                    name="observaciones"
                    value={formData.observaciones}
                    onChange={handleChange}
                    fullWidth
                    focused
                    required
                    inputProps={{ maxLength: 300 }}
                    size="small"
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    label="Kilometraje Final"
                    name="kilometraje_final"
                    type="number"
                    size="small"
                    focused
                    required
                    value={formData.kilometraje_final}
                    onChange={handleChange}
                    error={formData.kilometraje_final <= vehiculo.kilometraje}
                    helperText={
                      formData.kilometraje_final <= vehiculo.kilometraje
                        ? "El kilometraje final no puede ser menor o igual al registrado"
                        : ""
                    }
                    fullWidth
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    size="small"
                    label="Fecha"
                    name="fecha"
                    type="date"
                    focused
                    required
                    value={formData.fecha}
                    onChange={handleChange}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
              </Grid>

              <Grid
                container
                direction="row"
                justifyContent="space-between"
                mt={2}
              >
                <Grid item>
                  <Button
                    color="error"
                    variant="outlined"
                    onClick={onClose}
                    style={{ backgroundColor: "#fff" }}
                  >
                    Volver
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    type="submit"
                    color="success"
                    variant="contained"
                    disabled={disbtn || formData.kilometraje_final <= vehiculo.kilometraje}
                  >
                    Guardar
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </DialogContent>
        </form>
      </Dialog>

      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={3000}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity={severity}
            sx={{ width: "100%" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default NuevoMovimiento;
